import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import '@fil-global/gds-webcomponents/fil-icon/fil-icon.component'

import './style.scss'

const Switch = ({ id, items, defaultSelectedId, inversed, size, variations, onChange, extraClasses }) => {
  const [selectedToggle, setSelectedToggle] = useState()

  const handleChange = ({ item, itemIndex }) => {
    setSelectedToggle(item.id)
    onChange({ item, itemIndex })
  }

  const classes = {
    'fil-switch': true,
    'fil-switch--inversed': inversed,
    'fil-switch--small': size === 'small',
    'fil-switch--icon': items[0].icon,
    'fil-switch--chips': variations === 'chips'
  }

  useEffect(() => {
    setSelectedToggle(defaultSelectedId)
  }, [defaultSelectedId])

  useEffect(() => {
    if (defaultSelectedId) {
      setSelectedToggle(defaultSelectedId)
    } else {
      const [firstToggleItem] = items
      setSelectedToggle(firstToggleItem.value)
    }
  }, [])

  return (
    <React.Fragment>
      <div className={classnames(classes, extraClasses)}>
        {items.map((item, index) => {
          return (
            <div className="fil-switch__item" key={`fil-switch__item-${index}`}>
              <input
                className="fil-switch__field"
                type="radio"
                name={item.name}
                value={item.value}
                checked={selectedToggle === item.id}
                aria-checked={item.checked}
                onChange={() => {
                  handleChange({ item, itemIndex: index })
                }}
                {...(item.disabled ? { disabled: item.disabled } : {})}
                id={`${id}_${index}`}
                role="switch"
              />
              <label className="fil-switch__label" aria-label={item.description} htmlFor={`${id}_${index}`} id={`label_${id}_${index}`}>
                {item.icon && <fil-icon size="20" icon={item.icon} />}
                {item.label && <span>{item.label}</span>}
              </label>
            </div>
          )
        })}
      </div>
    </React.Fragment>
  )
}

Switch.propTypes = {
  items: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  defaultSelectedId: PropTypes.string,
  inversed: PropTypes.bool,
  size: PropTypes.oneOf(['standard', 'small']),
  variations: PropTypes.string,
  disabled: PropTypes.bool,
  disabledItems: PropTypes.array,
  onChange: PropTypes.func,
  extraClasses: PropTypes.string
}

Switch.defaultProps = {
  defaultSelectedId: '',
  inversed: false,
  size: 'standard',
  variations: '',
  disabled: false,
  disabledItems: [],
  onChange: () => {},
  extraClasses: ''
}

export default Switch
